import { createClient } from "@supabase/supabase-js";
import { getClientEnv, isSupabaseConfigured } from "@/lib/env";
import type { Database } from "@/lib/database.types";

const fallbackClientConfig = {
  supabaseUrl: "http://127.0.0.1:54321",
  supabaseAnonKey: "public-anon-key",
  siteUrl: "http://127.0.0.1:4173",
};

const env = isSupabaseConfigured() ? getClientEnv() : fallbackClientConfig;
const supabaseHost = new URL(env.supabaseUrl).host;

function createSupabaseAuthStorageKey(host: string) {
  const normalizedHost = host
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `logos-story-crafter-auth-token-${normalizedHost || "default"}`;
}

export const supabaseAuthStorageKey = createSupabaseAuthStorageKey(supabaseHost);
export const isLocalSupabaseUrl = ["127.0.0.1", "localhost"].includes(
  new URL(env.supabaseUrl).hostname,
);

export function clearSupabaseAuthStorage(storage = typeof window === "undefined"
  ? null
  : window.localStorage) {
  if (!storage) {
    return;
  }

  const keys = [
    supabaseAuthStorageKey,
    `${supabaseAuthStorageKey}-code-verifier`,
    `${supabaseAuthStorageKey}-user`,
  ];

  keys.forEach((key) => storage.removeItem(key));
}

export const supabase = createClient<Database>(
  env.supabaseUrl,
  env.supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storageKey: supabaseAuthStorageKey,
    },
  },
);

export const publicSupabase = createClient<Database>(
  env.supabaseUrl,
  env.supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false,
      storageKey: `${supabaseAuthStorageKey}-public`,
    },
  },
);

export const supabaseSiteUrl = env.siteUrl;
